import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Hero from './Hero';

const ImageBreaker4 = () => {
  return (
    <StaticQuery
      query={graphql`
        query ImageBreaker4Query {
          file(relativePath: { eq: "Prosjektlast.jpg" }) {
            childImageSharp {
              # Specify the image processing specifications right in the query.
              # Makes it trivial to update as your page's design changes.
              fluid(maxWidth: 1440, quality: 70) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      `}
      render={data => (
      <div className="ocean7 imagebreaker">
        <Hero
          fluid={data.file.childImageSharp.fluid}
          posY="0%"
          posX="75%"
          height="50vh"
          width="100%"
          />
          <div className="flex center column basePad">
            <h2>About the Ocean7 Group</h2>
            <p>Ocean7 is an independent ship operator specialising in project, breakbulk, heavy-lift, general and IMO/IMDG cargoes. For more than a decade, Ocean7 has provided tailor-made sea transportation solutions to customers worldwide, combining experienced shipping professionals with a flexible and hands-on approach.</p>
            
            <p>Ocean7 operates a diverse fleet of more than 45 owned, chartered and commercially managed multipurpose vessels, covering a broad range of sizes and capabilities. This allows Ocean7 to handle everything from individual heavy and oversized units to complete industrial projects, complex breakbulk shipments and general cargoes.</p>
            
            <p>Ocean7 trades worldwide, calling at both major international shipping hubs and smaller and more remote ports where flexibility, local knowledge and the right vessel are essential. Through its international organisation and network, Ocean7 provides customers with direct access to experienced shipping professionals across Europe, the Middle East, Asia and the United States.</p>
            
            <p>Ocean7 is built around long-term relationships, personal service and the ability to respond quickly to changing requirements. Its commercial, operational and technical expertise supports customers throughout the transportation process, from the initial enquiry and planning stage through loading, sea transportation and final delivery.</p>
            <p style={{width: "100%", textAlign: "left"}}><a href="https://www.ocean7group.com" target="_blank">www.ocean7group.com</a></p>
          </div>
        </div>
      )
    }
  />
)}
export default ImageBreaker4;
